import { MinimizeScreenIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Minimize2 = /* @__PURE__ */ createIcon(MinimizeScreenIcon, 'Minimize2');
